module.exports = __webpack_public_path__ + "img/xbtc.bc188287.png";